import get from 'lodash/get';
import React from 'react';
import { Workspace } from '../styled';

export const WorkspaceColumn = ({ host }) => { // eslint-disable-line import/prefer-default-export
  const workspaceName = get(host, 'workspace_name', '');

  return <Workspace>{ workspaceName }</Workspace>;
};
